const fuseDetailConstants = {
  FUSE_DETAIL_LOADING: "FUSE_DETAIL_LOADING",
  FUSE_DETAIL_SUCCESS: "FUSE_DETAIL_SUCCESS",
  FUSE_DETAIL_FAILURE: "FUSE_DETAIL_FAILURE",
};

const createFuseConstants = {
  CREATE_FUSE_LOADING: "CREATE_FUSE_LOADING",
  CREATE_FUSE_SUCCESS: "CREATE_FUSEL_SUCCESS",
  CREATE_FUSE_FAILURE: "CREATE_FUSE_FAILURE",
  CLEAR_CREATE_FUSE: "CLEAR_CREATE_FUSE",
  CLEAR_EDIT_FUSE: "CLEAR_EDIT_FUSE",
};

const editFuseConstants = {
  EDIT_FUSE_LOADING: "EDIT_FUSE_LOADING",
  EDIT_FUSE_SUCCESS: "EDIT_FUSEL_SUCCESS",
  EDIT_FUSE_FAILURE: "EDIT_FUSE_FAILURE",
};

const countryListConstants = {
  COUNTRY_LIST_LOADING: "COUNTRY_LIST_LOADING",
  COUNTRY_LIST_SUCCESS: "COUNTRY_LIST_SUCCESS",
  COUNTRY_LIST_FAILURE: "COUNTRY_LIST_FAILURE",
};

const fuseKPISConstants = {
  FUSE_KPI_LOADING: "FUSE_KPI_LOADING",
  FUSE_KPI_SUCCESS: "FUSE_KPI_SUCCESS",
  FUSE_KPI_FAILURE: "FUSE_KPI_FAILURE",
};

export {
  createFuseConstants,
  fuseDetailConstants,
  editFuseConstants,
  countryListConstants,
  fuseKPISConstants,
};
